module.exports = __webpack_public_path__ + "img/ht.b9e451b0.jpg";